import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../global/Button";
import Input from "../global/Input";
import ImageUploader from "../global/ImageUploader";
import { selectStyle, selectTheme } from "../../styles/selectStyles";
import { courtTypeOptions } from "../../data/options";
import Select from "react-select";
import RadioInput from "../global/RadioInput";
import { useCreateCourtMutation } from "../../lib/redux/services/sections/Courts";
import { toastMessage } from "../../utils/utils";
import { toast } from "react-toastify";
import MultiImageUploader from "../global/MultiImageUploader";
import ValidateError from "../global/ValidateError";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

type FormInput = {
  name: string;
  court_type: string;
  images: string;
  privacy_options: string;
};

const ClubInfoForm3 = () => {
  const { shared, inputs, courts, options }: DictionaryType =
    useGetDictionary();
  const {
    control,
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm<FormInput>();

  const [createCourt] = useCreateCourtMutation();
  const navigate = useNavigate();
  const { club_id } = useParams();
  const onSubmit = async (formData: FormInput, action: "save" | "addNew") => {
    try {
      const data = await toast.promise(
        createCourt({ data: formData, id: club_id }).unwrap(),
        toastMessage()
      );
    } catch (error) {}

    // Navigate based on the action
    if (action === "save") {
      navigate(`/auth/see-all-courts/${club_id}`);
    } else if (action === "addNew") {
      navigate(`/auth/add-new-court-1/${club_id}`);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((formData) => onSubmit(formData, "save"))}
      className="space-y-4 md:space-y-4 max-w-[814px] px-5 "
    >
      <div className="flex flex-row  items-center justify-center gap-6">
        <div className=" flex text-start flex-col items-basline justify-center gap-4 w-full">
          <div className="w-full">
            <Controller
              name="name"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                    type: "text",
                  }}
                  label={inputs.court_name}
                />
              )}
            />
            {errors.name && <ValidateError />}
          </div>
          <div className="w-full">
            <label className="block text-sm mb-2">
              {inputs.court_type}
              <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              name="court_type"
              rules={{ required: "Court type is required" }}
              render={({ field }) => (
                <Select
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  {...field}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                  theme={selectTheme}
                  options={courtTypeOptions(options)}
                  onChange={(selected) =>
                    // @ts-ignore only
                    field.onChange(selected ? selected.value : null)
                  }
                  value={
                    courtTypeOptions(options).find(
                      (option) => option.value === field.value
                    ) || null
                  }
                />
              )}
            />
            {errors.court_type && <ValidateError />}
          </div>
          <div className="w-full">
            <Controller
              name="privacy_options"
              control={control}
              rules={{ required: "Privacy is required" }}
              render={({ field }) => (
                <div className="flex flex-row items-center gap-8">
                  <label className="text-sm font-bold text-primary dark:text-white">
                    {inputs.privacy}?
                  </label>
                  <RadioInput
                    labelStyle="text-primary dark:text-white"
                    value="private"
                    label={inputs.private}
                    checked={field.value === "private"}
                    onChange={field.onChange}
                  />
                  <RadioInput
                    labelStyle="text-primary dark:text-white"
                    value="public"
                    label={inputs.public}
                    checked={field.value === "public"}
                    onChange={field.onChange}
                  />
                </div>
              )}
            />
            {errors.privacy_options && <ValidateError />}
          </div>
        </div>
        <div className="w-full">
          <MultiImageUploader
            height="h-[200px]"
            dimension={[390, 276]}
            fieldName="images"
            title={courts.court_image}
            errors={errors}
            register={register}
            setValue={setValue}
            clickHereRef="courtImage"
          />
        </div>
      </div>

      <div className="flex flex-row justify-center items-center pt-4 gap-10">
        <Button
          customeStyle="bg-white text-red-500  w-full rounded-full  text-base py-2.5"
          href={`/auth/club-info-2/${club_id}`}
          text={shared.back}
          width=""
        />
        <Button
          customeStyle="bg-white text-primary dark:text-white  w-full rounded-full  text-base py-2.5 border-primary border-2"
          text="Save"
          width="max-w-[400px] w-full"
          type="button"
          onClick={handleSubmit((formData) => onSubmit(formData, "save"))}
        />
        <Button
          customeStyle="bg-primary text-white w-full rounded-full text-base py-2.5 border-primary border-2"
          text={shared.save_and_add_new}
          width="max-w-[400px] w-full"
          type="button"
          onClick={handleSubmit((formData) => onSubmit(formData, "addNew"))}
        />
      </div>
    </form>
  );
};

export default ClubInfoForm3;
